import React from 'react'
import styled from 'styled-components'

const BulkEmailErrors = styled.div`
  overflow-y: auto;
  max-height: 20rem;
`

const BulkIssuanceErrors = ({ bulkIssuanceResult }) => {
  return (
    <>
      {bulkIssuanceResult?.emailsSuccess.length > 0 ||
      bulkIssuanceResult?.emailsFailure.length > 0 ||
      bulkIssuanceResult?.invalidEmails.length > 0 ? (
        <BulkEmailErrors>
          {/* Only Display the section if there are emails that were invaild */}
          {bulkIssuanceResult.invalidEmails.length > 0 ? (
            <div>
              <p>
                <b>Invalid emails not sent:</b>{' '}
                {bulkIssuanceResult.invalidEmails.length}
              </p>
              <ul>
                {bulkIssuanceResult.invalidEmails.map((email) => (
                  <li key={email}>{email}</li>
                ))}
              </ul>
            </div>
          ) : (
            <></>
          )}

          {/* Only Display the section if there are emails that were  unsuccessful */}
          {bulkIssuanceResult.emailsFailure.length > 0 ? (
            <div>
              <p>
                <b>Emails unsuccessfully sent:</b>{' '}
                {bulkIssuanceResult.emailsFailure.length}
              </p>
              <ul>
                {bulkIssuanceResult.emailsFailure.map((email) => (
                  <li key={email}>{email}</li>
                ))}
              </ul>
            </div>
          ) : (
            <></>
          )}

          {/* Only Display the section if there are emails that were successful */}
          {bulkIssuanceResult.emailsSuccess.length > 0 ? (
            <div>
              <p>
                <b>Emails successfully sent:</b>{' '}
                {bulkIssuanceResult.emailsSuccess.length}
              </p>
              <ul>
                {bulkIssuanceResult.emailsSuccess.map((email) => (
                  <li key={email}>{email}</li>
                ))}
              </ul>
            </div>
          ) : (
            <></>
          )}
        </BulkEmailErrors>
      ) : (
        <></>
      )}
    </>
  )
}

export default BulkIssuanceErrors
